<template>
    <div class="d-flex flex-row flex-nowrap align-items-center w-abs-75">
        <ButtonComp
            button-type="Custom"
            icon="fas fa-sort-up"
            class="btn-sm border-0 text-green-500 no-focus"
            :class="{
                'opacity-25': value === 1,
                'opacity-75 opacity-hover-100': value !== 1,
            }"
            :disabled="value === 1"
            tabindex="-1"
            @click="onUpClicked"
        ></ButtonComp>

        <div class="px-2">{{ value }}</div>

        <ButtonComp
            button-type="Custom"
            icon="fas fa-sort-down"
            class="btn-sm text-red-500 no-focus"
            :class="{
                'opacity-25': numberOfLegs !== null && value == numberOfLegs,
                'opacity-75 opacity-hover-100': numberOfLegs === null || value !== numberOfLegs,
            }"
            tabindex="-1"
            :disabled="numberOfLegs !== null && value == numberOfLegs"
            @click="onDownClicked"
        ></ButtonComp>
    </div>
</template>
<script lang="ts" setup>
import { ButtonComp } from '@/components';
import type { RelayTeamContestant } from '@/objects/generated';
import { computed } from 'vue';

const props = defineProps<{
    value: number | null;

    row: RelayTeamContestant;

    rows?: RelayTeamContestant[];
}>();

const numberOfLegs = computed(() => {
    if (props.rows === undefined) {
        return null;
    }
    return props.rows?.filter((r) => r.ContestantID === props.row.ContestantID).length ?? null;
});

const emit = defineEmits<{
    (e: 'buttonUpClicked', row: RelayTeamContestant): void;

    (e: 'buttonDownClicked', row: RelayTeamContestant): void;
}>();

const onUpClicked = () => {
    emit('buttonUpClicked', props.row);
};

const onDownClicked = () => {
    emit('buttonDownClicked', props.row);
};
</script>
